import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseResponse } from '../../shared';

@Injectable()
export class InvitationService {
    baseUrl = `${environment.api.endpoint}/User`;

    constructor(private httpClient: HttpClient) {}

    getUser(username: string): Observable<BaseResponse<any>> {
        return this.httpClient.get<BaseResponse<any>>(`${this.baseUrl}/GetUserByUserName/${username}`);
    }

    confirmUser(request: { username: string; password: string }): Observable<BaseResponse<any>> {
        return this.httpClient.post<BaseResponse<any>>(`${this.baseUrl}/ConfirmUser`, request);
    }
}
